
import Vue from "vue"
import { mapGetters } from "vuex"
import FooterBase from "~/components/base/footerBase"
import { GET_USER } from "~/store/auth/getters"
import { getV4Host } from "~/scripts/useful-functions"

export default Vue.extend({
  name: "TheFooterUS",
  extends: FooterBase,
  props: {
    uri: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    showUSLinks: false
  }),
  computed: {
    ...mapGetters("auth", {
      user: GET_USER
    }),
    v4Host(): string {
      if (!this.showUSLinks) {
        return this.$config.v4Host
      }
      return getV4Host(this.$config.v4Host, "us")
    },
    isDriverPage(): boolean {
      return this.uri === "/us/become-an-anyvan-shipping-partner/"
    }
  },
  created() {
    if (this.isDriverPage) {
      // @ts-ignore-next-line
      this.email = "shipping-partners@anyvan.com"
    }
  }
})
